export const deeplinkConfigs = new Map<
  string,
  { intentUrl: string; deeplinkFallbackUrl: string }
>([
  [
    'ems/token',
    {
      intentUrl: myESET.envData.EMSTokenIntentUrl,
      deeplinkFallbackUrl: myESET.envData.EMSTokenFallbackUrl,
    },
  ],
])
